import { useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'

export const FirstColumnCell = (dataTable, rowId, val, rowIndex) => {
  const [isHovered, setIsHovered] = useState(false)

  const allReportNameRowId = dataTable
    ?.filter((item) => item.isReportNameRow)
    .map((item) => item.id)

  const isReportNameRow = allReportNameRowId.includes(rowId)

  const onMouseEnter = () => {
    setIsHovered(true)
  }

  const onMouseLeave = () => {
    setIsHovered(false)
  }

  const isEvenRow = rowIndex % 2 === 0
  const style = {
    backgroundColor: isHovered ? '#EDF5FE' : isEvenRow ? '#F9F9F9' : '#FFFFFF',
  }

  const fromCompaniesName = `${I18n.t(
    'userManagement.packageList.FROM',
  )} ${val}+ ${I18n.t('userManagement.packageList.COMPANIES')}`

  return (
    <Element
      className={isReportNameRow ? 'fw600' : ''}
      style={
        isReportNameRow ? { fontSize: 14, backgroundColor: '#D5D5D5' } : style
      }
      elementName="td"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {isReportNameRow ? val : fromCompaniesName}
    </Element>
  )
}
